import { FormErrors } from "./form-errors";
import { PasswordInput } from "./password-input";
import { GalleryVerticalEnd } from "lucide-react";
import { Form, Link, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";
import { Spinner } from "@/components/ui/spinner";
import { Button } from "@/components/ui/button";
import { Field, FieldGroup, FieldLabel } from "@/components/ui/field";
import { passwordPath } from "@/routes";

interface PasswordResetFormProps extends React.ComponentProps<"div"> {
  token: string;
}

export function PasswordResetForm({
  token,
  className,
  ...props
}: Readonly<PasswordResetFormProps>) {
  const { t } = useTranslation();
  const { app_name: appName, errors } = usePage().props;
  return (
    <div className={cn("flex flex-col gap-6", className)} {...props}>
      <Form action={passwordPath(token)} method="put" disableWhileProcessing>
        {({ processing }) => (
          <FieldGroup>
            <FormErrors
              errors={errors}
              targets={{
                email_address: "email_address",
                password: "password",
                password_confirmation: "password_confirmation",
              }}
            />
            <div className="flex flex-col items-center gap-2 text-center">
              <Link
                href="/login"
                className="flex flex-col items-center gap-2 font-medium"
              >
                <div className="flex size-8 items-center justify-center rounded-md">
                  <GalleryVerticalEnd className="size-6" />
                </div>
                <span className="sr-only">{appName}</span>
              </Link>
              <h1 className="text-page font-display">
                {t("auth.create_password")}
              </h1>
            </div>
            <Field>
              <FieldLabel htmlFor="password">{t("auth.password")}</FieldLabel>
              <PasswordInput
                id="password"
                name="password"
                autoComplete="new-password"

                placeholder="********"
                required
              />
            </Field>
            <Field>
              <FieldLabel htmlFor="password_confirmation">
                {t("auth.password_confirmation")}
              </FieldLabel>
              <PasswordInput
                id="password_confirmation"
                name="password_confirmation"
                autoComplete="new-password"

                placeholder="********"
                required
              />
            </Field>
            <Field>
              <Button
                type="submit"
                disabled={processing}
                aria-busy={processing}
              >
                {processing && <Spinner />}
                {t("auth.save_password")}
              </Button>
            </Field>
          </FieldGroup>
        )}
      </Form>
    </div>
  );
}
